import { NgModule } from '@angular/core';
import { ErrorMessagesModal, SimpleFileUploaderComponent } from './simple-file-uploader.component';
import {PublicImageUploaderComponent} from './public-image-uploader.component';
import {MatIconModule} from '@angular/material/icon';
import {CommonModule} from '@angular/common';
import { StringFormatPipe } from '@fuse/pipes/stringFormat.pipe';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    TranslateModule,
  ],
    exports: [
      SimpleFileUploaderComponent,
        PublicImageUploaderComponent,
    ],
    declarations: [
      SimpleFileUploaderComponent,
      PublicImageUploaderComponent,
      ErrorMessagesModal,
    ],
    providers: [
      StringFormatPipe,
    ],
})
export class SimpleFileUploaderModule { }
